export const sortByListValues = [
  { id: "0", label: "Oldest Requested Date", value: "ASC", },
  { id: "1", label: "Newest Requested Date", value: "DESC", },
]

export const breadcrumbMapArr = [
  { name: 'Home', link: "/dashboard", eventType: "Link", },
]

export const deliveryRequirements = [
  { label: "All", value: "ALL" },
  { label: "Pick Up", value: "PICKUP" },
  { label: "Delivery", value: "DELIVERABLE" },
]